// src/hooks/useNoIndex.js
import { useEffect } from 'react';

/**
 * Custom hook to add noindex, nofollow meta tags to prevent search engines from indexing
 * This should be used on all member-only/protected pages
 */
const useNoIndex = () => {
  useEffect(() => {
    // Create or update the robots meta tag
    let robotsMetaTag = document.querySelector('meta[name="robots"]');

    if (!robotsMetaTag) {
      robotsMetaTag = document.createElement('meta');
      robotsMetaTag.setAttribute('name', 'robots');
      document.head.appendChild(robotsMetaTag);
    }

    // Set content to noindex, nofollow
    robotsMetaTag.setAttribute('content', 'noindex, nofollow');

    // Cleanup function to remove the tag when component unmounts
    return () => {
      const metaTag = document.querySelector('meta[name="robots"]');
      if (metaTag && metaTag.getAttribute('content') === 'noindex, nofollow') {
        metaTag.remove();
      }
    };
  }, []);
};

export default useNoIndex;
